<template>
  <div class="image-uploader">
    <a-upload
      accept="image/*"
      list-type="picture-card"
      :default-file-list="fileList"
      :before-upload="beforeUpload"
      :customRequest="customRequest"
      @preview="handlePreview"
      :remove="handleRemove"
      @change="handleChange"
    >
      <div v-if="fileList.length < num" :style="`width:${width}px;height:${height}px;line-height:${height}px;`">
        <div class="ant-upload-text"><a-icon type="plus" />上传图片</div>
      </div>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%; padding: 10px" :src="imageUrl" />
    </a-modal>
  </div>
</template>

<script>
import { uploadFileDirectToOss } from "@/utils/directOssUpload";

export default {
  name: "ImageUploader",
  props: {
    value: {
      type: String,
      default: "",
    },
    num: {
      type: Number,
      default() {
        return 1;
      },
    },
    width: {
      type: Number,
      default() {
        return 134;
      },
    },
    height: {
      type: Number,
      default() {
        return 134;
      },
    },
  },
  data() {
    return {
      fileList: [],
      previewVisible: false,
      imageUrl: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.fileList = [];
          return;
        }
        const urls = String(newVal)
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
        this.fileList = urls.map((url, index) => ({
          uid: `-${index}`,
          name: `image-${index}.jpg`,
          status: "done",
          url,
        }));
      },
    },
  },
  methods: {
    handleChange(info) {
      if (!info.file || info.file.status !== "done") {
        return;
      }
      const imageUrl = info.file.response?.url || "";
      if (!imageUrl) {
        return;
      }
      this.fileList = [
        ...this.fileList,
        {
          uid: info.file.uid,
          name: info.file.name,
          status: "done",
          url: imageUrl,
        },
      ];
      this.emitValue();
    },
    beforeUpload(file) {
      const isImage = file.type && file.type.startsWith("image/");
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG、GIF 格式");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB");
      }
      if (this.fileList.length >= this.num) {
        this.$message.error(`最多只能上传 ${this.num} 张图片`);
      }
      return isImage && isLt5M && this.fileList.length < this.num;
    },
    async customRequest(options) {
      const { file, onProgress, onSuccess, onError } = options;
      try {
        const result = await uploadFileDirectToOss(file, { onProgress });
        if (typeof onSuccess === "function") {
          onSuccess({ url: result.url }, file);
        }
      } catch (error) {
        this.$message.error(
          (error && error.response && error.response.data && error.response.data.msg) ||
            error.message ||
            "图片上传失败"
        );
        if (typeof onError === "function") {
          onError(error);
        }
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      this.previewVisible = true;
      this.imageUrl = file.url;
    },
    async handleRemove(file) {
      this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      this.emitValue();
    },
    emitValue() {
      const imageUrls = this.fileList.map((file) => file.url).join(",");
      this.$emit("input", imageUrls);
    },
  },
};
</script>

<style scoped>
.image-uploader > .ant-upload {
  top: 20px;
  width: 128px;
  height: 128px;
}
</style>
